import {Button} from '../button/button';
import css from './validate-setlist.module.scss';
import {useDispatch} from 'react-redux';
import {setSlideUpTitle} from '../../pages/setlist/setlist.slice';

export const ValidateSetlist = () => {
	const dispatch = useDispatch();

	return (
		<div className={css.container}>
			<p className={css.text}>Search and add new songs, or reorder the setlist.</p>
			<Button
				onClick={() => {
					dispatch(setSlideUpTitle('Song Played?'));
				}}
				name="Validate Setlist"
				color="blue"
			/>
		</div>
	);
};
